import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { StateType } from '../../../state/state.types';

function getAdviceMetadata({ results, queryParams }: StateType) {
  return {
    type: results.adviceAction && results.adviceAction.type,
    query_key: results.lastResponse,
    search_type: queryParams.type,
  };
}

export const reportAdviceClicked = () => (
  dispatch: Function,
  getState: () => StateType,
) => {
  const state = getState();
  doctrineAnalytics('Search AdviceClicked', {
    ...getAdviceMetadata(state),
  });
};

export const reportAdviceShown = () => (
  dispatch: Function,
  getState: () => StateType,
) => {
  const state = getState();
  doctrineAnalytics('Search AdviceShown', {
    ...getAdviceMetadata(state),
  });
};
